import React, { useEffect } from "react"
import i18n from "i18n"

import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import Typography from "@mui/material/Typography"
import PropTypes from "prop-types"
import DeltaDetailsDataGrid from "./DeltaDetailsDataGrid"

const DialogCertMeasures = ({ open, onClose, part }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            textTransform: "uppercase",
            fontSize: "1.25rem",
          }}
        >
          {i18n.t("certMeasurements.histTitle")}
        </Typography>
        <IconButton onClick={onClose} sx={{ ml: 1 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography
          sx={{
            fontWeight: "bold",
            mb: 1,
          }}
        >
          {i18n.t("certMeasurements.description")}:
        </Typography>
        <Typography
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            width: "100%",
            display: "block",
            mb: 3,
          }}
        >
          {part?.name}
        </Typography>
        {part?.cert?.measure_delta_details?.length > 0 && (
          <DeltaDetailsDataGrid details={part.cert.measure_delta_details} />
        )}
      </DialogContent>
    </Dialog>
  )
}

DialogCertMeasures.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  part: PropTypes.object,
}

export default DialogCertMeasures
